import { useRef } from "react";
import { useWindowEvent as s } from "./use-window-event.js";
var a = ((r) => (r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))(a || {});
function u() {
  let e = useRef(0);
  return s(true, "keydown", (r) => {
    r.key === "Tab" && (e.current = r.shiftKey ? 1 : 0);
  }, true), e;
}
export {
  a as Direction,
  u as useTabDirection
};
